import React, { Component } from "react";
import { NumberInput } from "../components/NumberInput.tsx";
import { ErrorBox } from "../components/ErrorBox.tsx";
import { NextButton } from "../components/NextButton.tsx";
import { PreviousButton } from "../components/PreviousButton.tsx";
import { LenderRow } from "../components/LenderRow";

interface IProps {
  prevStep(): void;
  nextStep(): void;
  updateLead(props: any): void;
  gtmEvent(): void;
  grossIncome?: number;
  variableIncome?: number;
  isJoint: boolean;
  consent: boolean;
  mortgageamount: number;
  isHH: boolean;
}

interface IState {
  hasError: boolean;
  errors?: string[];
  grossIncome?: number;
  variableIncome?: number;
  consent?: boolean;
}

export class Income extends Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      hasError: false,
      grossIncome: this.props.grossIncome,
      variableIncome: this.props.variableIncome,
    };
  }

  componentDidMount(): void {
    this.props.gtmEvent();
  }

  nextStep() {
    const errors: string[] = [];
    if (!this.state.grossIncome) {
      errors.push("Gross Income is required");
    }

    // if (!this.state.consent){
    // if (this.props.mortgageamount>180000 && !this.state.consent){
    if (!this.state.consent) {
      errors.push("Consent is required");
    }

    if (errors.length > 0) {
      this.setState({ hasError: true, errors });
      return;
    }
    this.setState({ hasError: false, errors: [] });
    this.props.nextStep();
  }

  render() {
    return (
      <header className="App-header">
        {/* <h1 className='l'><span className='doddltext'>And finally,</span><br />what is your approximate <span className='doddltext'>{this.props.isJoint ? 'joint ' : ''}income?</span></h1> */}
        {/* <h1 className='l'>And finally, what is your approximate <span className='doddltext'>{this.props.isJoint ? 'joint ' : ''}income?</span></h1> */}
        <h1 className="l">
          {this.props.mortgageamount > 180000 ? "And finally, what " : "What "}{" "}
          is your approximate{" "}
          <span className="doddltext">
            {this.props.isJoint ? "joint " : ""}income?
          </span>
        </h1>
        <div className="wrapper">
          <div className="row">
            <div className="column2 justify-e">
              <NumberInput
                id="grossIncome"
                key="grossIncome"
                label={
                  <>
                    Approximate <strong>gross income</strong>, per annum
                  </>
                }
                value={this.props.grossIncome}
                classes={
                  this.state.hasError && !this.state.grossIncome ? "e" : ""
                }
                onChange={(e) => {
                  this.setState({ grossIncome: e.target.value });
                  this.props.updateLead({ grossBasicIncome: e.target.value });
                }}
              />
            </div>
            <div className="column2 justify-s">
              <NumberInput
                id="variableIncome"
                key="variableIncome"
                label={
                  <>
                    Any <strong>variable income</strong>, bonuses etc.
                  </>
                }
                value={this.props.variableIncome}
                classes={
                  this.state.hasError && !this.state.variableIncome ? "e" : ""
                }
                onChange={(e) => {
                  var forceNumber = e.target.value
                    ? parseFloat(e.target.value)
                    : 0;
                  this.setState({ variableIncome: forceNumber });
                  this.props.updateLead({ grossVariableIncome: forceNumber });
                }}
              />
            </div>
          </div>
          {/* {(this.props.mortgageamount<180000)&&(<> */}
          {
            <label htmlFor="consent">
              We will also email you our Terms of Business and Privacy Notice
            </label>
          }
          {
            <div className="row">
              <div className="d-column">
                <input
                  id="consent"
                  type="checkbox"
                  name="consent"
                  checked={this.props.consent}
                  className={
                    this.state.hasError && !this.state.consent ? "e" : ""
                  }
                  onChange={(e) => {
                    this.setState({ consent: e.target.checked });
                    this.props.updateLead({ consentGiven: e.target.checked });
                  }}
                />
                <label htmlFor="consent">
                  I consent for doddl to process the information I provided, and
                  to contact me in relation to my mortgage and associated
                  insurances as per the{" "}
                  <a
                    style={{ color: "blue" }}
                    href="https://doddl.ie/privacy-notice/"
                    target="_blank"
                  >
                    doddl Privacy Notice
                  </a>{" "}
                  and{" "}
                  <a
                    style={{ color: "blue" }}
                    href="https://doddl.ie/terms-conditions/"
                    target="_blank"
                  >
                    Terms of Business
                  </a>
                </label>
              </div>
            </div>
          }
          {/* </>)} */}
          {this.state.hasError && <ErrorBox errors={this.state.errors!} />}
          <div className="row">
            <div className="button-group">
              <PreviousButton onClick={() => this.props.prevStep()} />
              {/* <NextButton customLabel='Finish' onClick={() => this.nextStep()} /> */}
              <NextButton customLabel="Next" onClick={() => this.nextStep()} />
            </div>
          </div>
          <div className="row mt-2">
            <LenderRow />
          </div>
        </div>
      </header>
    );
  }
}
